export enum IamNamespaces {
  PDB_ADMINS = 'pdb-admins',
  SETEL_ADMINS = 'setel-admins',
}

export const LOCAL_STORAGE_KEY = {
  SESSION: 'WEB-ZENDESK-SESSION',
  navigationDropdownTooltip: 'NAVIGATION-DROPDOWN-TOOLTIP',
} as const;

export interface ILoginResponse {
  require2Fa: false;
  accessToken: string;
  expiresIn: number;
  refreshToken: string;
  authenticityToken?: string;
  resetPasswordToken?: string;
  passwordExpiresIn?: number;
  username: string;
}

export interface ProcessSessionInput {
  accessToken: string;
  expiresIn: number;
  refreshToken: string;
  username?: string;
}

export interface I2FALoginResponse {
  require2Fa?: true;
  authenticityToken?: string;
  resetPasswordToken?: string;
  passwordExpiresIn?: number;
}

export interface ISession {
  email: string;
  accessToken: string;
  refreshToken: string;
  expiresAt: string;
  preferred_username?: string;
  username: string;
}

export interface IAccessRoles {
  roles: string[];
}

export interface IResourceAccess {
  'setel-ops': IAccessRoles;
}

export interface ISessionData {
  resource_access: IResourceAccess;
  preferred_username: string;
  name: string;
  email: string;
  sub: string;
  namespace: IamNamespaces;
  issuer: string;
  iat: number;
  exp: number;
}

export interface RefreshSession {
  accessToken: string;
  expiresIn: number;
  refreshExpiresIn: number;
  refreshToken: string;
  username?: string;
}
